import { RouteConfig } from 'vue-router';

const list: Array<RouteConfig> = [
  {
    path: 'stacks',
    name: 'computeStacks',
    props: true,
    component: () => import('@/self-service/pages/compute/stacks/computeStacks'),
    meta: {
      title: $t => $t('Stacks'),
      restrictions: {
        action: 'read',
        resource: 'compute_stacks'
      },
    },
    children: [
      {
        path: ':stackId',
        name: 'computeStackDetails',
        meta: {
          title: $t => $t('Stack details')
        }
      },
      {
        path: 'add',
        component: () => import('@/self-service/pages/compute/stacks/computeStackAdd.vue'),
        name: 'computeStackAdd',
        meta: {
          title: $t => $t('Add stack'),
          restrictions: {
            action: 'create',
            resource: 'compute_stacks'
          },
        }
      },
    ]
  }
];

export default list;
